import * as modules from "./modules/";
import config from "../../../../../config";

const { vendor } = config;
const H5 = modules[vendor] ? modules[vendor] : modules["default"];

export default H5;
